import { Injectable, APP_INITIALIZER } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AuthService } from './services/auth.service';

/**
 * Before the first route/component loads, renew an expired access token when a
 * refresh token is still present. Prevents pages from painting empty/error
 * state after opening a deep link following a long idle period.
 */
export function initializeAuthSession(authService: AuthService): () => Promise<void> {
  return () => {
    if (!authService.isAuthenticated()) {
      return Promise.resolve();
    }
    if (!authService.isTokenExpired() && authService.getToken()) {
      return Promise.resolve();
    }
    // Wait for refresh (or failure) before any page can load data
    return firstValueFrom(authService.ensureValidSession()).then((ok) => {
      if (!ok) {
        // Session dead — leave cleared; AuthGuard will send user to login
        return;
      }
    });
  };
}

export const AUTH_SESSION_INITIALIZER = {
  provide: APP_INITIALIZER,
  useFactory: initializeAuthSession,
  deps: [AuthService],
  multi: true,
};
